import camelcaseKeys from "camelcase-keys";

import { apiSlice } from "@/lib/rtkquery";
import { ApiResponse, StorageDTO } from "@/types";

type StorageResponse = ApiResponse<StorageDTO>;

const storageApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    createStorage: build.mutation<StorageDTO, StorageDTO>({
      query: (data) => {
        return {
          url: "api/v1/storage",
          method: "POST",
          body: data,
        };
      },
      transformResponse: (response: StorageResponse) =>
        camelcaseKeys(response.results),
    }),
  }),
});

export const { useCreateStorageMutation } = storageApi;
